import {DataScope} from '@sollapay/enums';

import {usePermissions} from '@/features/authentication';

/** `own`: only sees their own accounts. `grouped`: sees the firm, can write some of it. `readonly`: sees the firm, can write none of it. */
export type TrustAccountListMode = 'own' | 'grouped' | 'readonly';

/** Derived from scopes, not `roleKey`, so any future role with the same scopes presents consistently. */
export function useTrustAccountListMode(): {mode: TrustAccountListMode} {
  const {readScope, writeScope} = usePermissions();

  const mode: TrustAccountListMode =
    readScope !== DataScope.FIRM ? 'own' : writeScope !== null ? 'grouped' : 'readonly';

  return {mode};
}
